import { Action } from '@ngrx/store';
import { IChecklist } from '@signal/asp-data-commons';

export enum ChecklistActionTypes {
    LOAD_ALL_CHECKLIST = '[Checklist Setup] Load all checklist',
    LOAD_ALL_CHECKLIST_SUCCESS = '[Checklist Setup] Load all checklist success',
    LOAD_ALL_CHECKLIST_FAILURE = '[Checklist Setup] Load all checklist failure',
    LOAD_CHECKLIST = '[Checklist Setup] Load selected checklist',
    UPDATE_CHECKLIST = '[Checklist Setup] Update checklist',
    UPDATE_CHECKLIST_SUCCESS = '[Checklist Setup] Update checklist success',
    UPDATE_CHECKLIST_FAILURE = '[Checklist Setup] Update checklist failure',
}

export class LoadAllChecklist implements Action {
    readonly type: string = ChecklistActionTypes.LOAD_ALL_CHECKLIST;
  
    constructor() {}
  }
  
  export class LoadAllChecklistSuccess implements Action {
    readonly type = ChecklistActionTypes.LOAD_ALL_CHECKLIST_SUCCESS;
  
    constructor(public payload: { checklistDetails: IChecklist[] }) {
    }
  }
  
  export class LoadAllChecklistFailure implements Action {
    readonly type = ChecklistActionTypes.LOAD_ALL_CHECKLIST_FAILURE;
  
    constructor(public payload: { error: string }) {
    }
  }

  export class LoadChecklist implements Action {
    readonly type = ChecklistActionTypes.LOAD_CHECKLIST;

    constructor(public payload: {checklist : string}) {

    }
  }

  export class UpdateChecklist implements Action {
    readonly type = ChecklistActionTypes.UPDATE_CHECKLIST;
  
    constructor(public payload: { checklist: IChecklist }) {
    }
  }
  
  export class UpdateChecklistSuccess implements Action {
    readonly type = ChecklistActionTypes.UPDATE_CHECKLIST_SUCCESS;
  
    constructor(public payload: { checklist: IChecklist }) {
    }
  }
  
  export class UpdateChecklistFailure implements Action {
    readonly type = ChecklistActionTypes.UPDATE_CHECKLIST_FAILURE;
  
    constructor(public payload: { error: string }) {
    }
  }

  export type ChecklistActions =
  LoadAllChecklist
  | LoadAllChecklistSuccess
  | LoadAllChecklistFailure
  | LoadChecklist
  | UpdateChecklist
  | UpdateChecklistSuccess
  | UpdateChecklistFailure
